import { createContext, type ReactNode, use, useEffect, useState } from 'react';

/** One step of the top bar's breadcrumbs; the last is the page itself. */
export interface Crumb {
  label: string;
  to?: string;
}

const CrumbsContext = createContext<{ crumbs: Crumb[]; set: (crumbs: Crumb[]) => void }>({
  crumbs: [],
  set: () => undefined,
});

export function CrumbsProvider({ children }: { children: ReactNode }) {
  const [crumbs, set] = useState<Crumb[]>([]);
  return <CrumbsContext value={{ crumbs, set }}>{children}</CrumbsContext>;
}

export function useCrumbList(): Crumb[] {
  return use(CrumbsContext).crumbs;
}

/** Sets the top bar's breadcrumbs while this page is open. */
export function useCrumbs(...crumbs: Crumb[]) {
  const { set } = use(CrumbsContext);
  const key = JSON.stringify(crumbs);
  useEffect(() => {
    set(JSON.parse(key) as Crumb[]);
  }, [key, set]);
}
